import React, { useState, useMemo, useCallback } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import CustomersForm from './CustomersForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { FormCustom, Input } from '../../Components/Form/Form';
import ReactPlaceholder from 'react-placeholder/lib';
import { useSelector } from 'react-redux';

const Customers = ({ nameSingle, namePlural, separator, publicCustomers, onAddCustomers, customersAdded, showButttonAdd, typeList }) => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [formParams, setFormParams] = useState({})
    const [ready] = useState(true)

    const [showPassword, setShowPassword] = useState(false)
    const [contentPassword, setContentPassword] = useState('')

    const permissions = useSelector(store => store.session.permissions)
    const actionsModule = Helpers.getActions({ permissions, module: 'clientes' })

    const [dataFilter, setDataFilter] = useState({
        p_id_customers: '',
        p_name_customers: '',
        p_last_name_customers: '',
        p_last_mother_name_customers: '',
    })

    const handleInsertUpdate = ({ data, fnCallback }) => {
        setLoadSubmit(true)
        Controllers.customers.customers_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
                setFormParams({})

                if (fnCallback().isNew) {
                    setContentPassword(<div className="d-flex justify-content-center flex-column align-items-center">
                        <div>Usuario: <strong>{res.data.id}</strong></div>
                        <div>Contraseña: <strong>{fnCallback().password_user}</strong></div>
                    </div>)
                    setShowPassword(true)
                }
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
            })
    }

    const handleGet = useCallback(e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idCustomers) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idCustomers } = $this.dataset

        let promises = [
            Controllers.customers.get_customers_id({ p_id_customers: idCustomers }),
            Controllers.customers.get_customers_bank({ p_id_customers: idCustomers }),
            Controllers.customers.get_customers_social({ p_id_customers: idCustomers })
        ]

        Promise.all(promises).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idCustomers}`)
            setDataUpdated({ data: res[0].data })
            let params = {
                ...formParams,
            }
            if (res[1].data?.id_bank) {
                params.bank = res[1].data
            }
            if (res[2].data.length > 0) {
                params.social = res[2].data
            }
            setFormParams(params)
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
        })
            .finally(() => $this.innerHTML = buttonHTML)
    }, [formParams, nameSingle])

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.customers.customers_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmitDelete(false)
            })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idCustomers, nameCustomers } = e.currentTarget.dataset
        setDataDeleted({
            p_id_customers: idCustomers,
            p_name_customers: nameCustomers
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const handleShowCredentials = e => {
        const { idCustomers } = e.currentTarget.dataset
        const button = e.currentTarget
        const buttonHTML = button.innerHTML
        button.disabled = true
        button.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'

        Controllers.customers.get_customers_id({ p_id_customers: idCustomers }).then(res => {
            if (res.response !== 'success') {
                Helpers.toast.construct({ ...res, toast })
                return
            }

            setContentPassword(<div className="d-flex justify-content-center flex-column align-items-center">
                <div>Usuario: <strong>{res.data.id_customers}</strong></div>
                <div>Contraseña: <strong>{res.data.password_user}</strong></div>
                <small className="text-muted mt-2">Acceso a la oficina virtual del distribuidor</small>
            </div>)
            setShowPassword(true)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                button.disabled = false
                button.innerHTML = buttonHTML
            })
    }

    const dtRows = useMemo(() => {
        let columns = [];
        if (typeList === 'CUSTOMERS_LIST') {
            columns = [
                { name: 'id_customers', text: 'ID', align: 'center' },
                { name: 'full_name', text: 'Nombres' },
                { name: 'id_upline', text: 'Upline', align: 'center' },
                { name: 'id_sponsor', text: 'Sponsor', align: 'center' },
                { name: 'full_name_sponsor', text: 'Nombres Sponsor' },
                { name: 'name_plan', text: 'Rango', align: 'center' },
                { name: 'date_registration', text: 'Fecha de Ingreso', align: 'center' },
                {
                    name: 'point_current_customers', text: 'Puntos', align: 'center', render: r => {
                        return <div className={'badge badge-' + (parseInt(r.point_current_customers) >= Helpers.config.pointMinRange ? 'success' : (parseInt(r.point_current_customers) > 0 ? 'warning' : 'danger'))}>
                            {r.point_current_customers}
                        </div>
                    }
                },
                { name: 'point_business_customers', text: 'Valor Negocio', align: 'center' },
                {
                    name: 'id_status', text: 'Estatus', align: 'center', render: r => <div className={'badge badge-' + (parseInt(r.id_status) === 1 ? 'success' : 'danger')}>
                        {parseInt(r.id_status) === 1 ? 'Activo' : 'De Baja'}
                    </div>
                },
                { name: 'key_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'code_country', text: 'País', align: 'center' },
                { name: 'user_created', text: 'Usuario', align: 'center' },
            ]
        } else {
            columns = [
                { name: 'id_customers', text: 'ID', align: 'center' },
                { name: 'name_customers', text: 'Nombres' },
                { name: 'last_name_customers', text: 'Apellido Paterno' },
                { name: 'last_name_mot_customers', text: 'Apellido Materno' },
                { name: 'id_upline', text: 'Upline', align: 'center' },
                { name: 'id_sponsor', text: 'Sponsor', align: 'center' },
                { name: 'full_name_sponsor', text: 'Nombres Sponsor' },
                { name: 'key_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'last_name_period_purchase_customers', text: 'Último Periódo de Compra' },
                {
                    name: 'id_status', text: 'Estatus', align: 'center', render: r => <div className={'badge badge-' + (parseInt(r.id_status) === 1 ? 'success' : 'danger')}>
                        {parseInt(r.id_status) === 1 ? 'Activo' : 'De Baja'}
                    </div>
                },
            ]

            columns.push({
                name: 'save_online', text: 'Registro En Línea',
                align: 'center',
                render: u => {
                    let saveOnline = parseInt(u.save_online)
                    return <strong className={'text-' + (saveOnline === 0 ? 'dark' : 'success')}>
                        {saveOnline === 0 ? 'NO' : 'SI'}
                    </strong>
                }
            })
            columns.push({
                name: 'pay_membership', text: 'Pago Membresía',
                align: 'center',
                render: u => {
                    if (parseInt(u.save_online) !== 1) {
                        return ''
                    }
                    let payMembership = parseInt(u.pay_membership)
                    return <strong className={'text-' + (payMembership === 0 ? 'danger' : 'success')}>
                        {payMembership === 0 ? 'NO' : 'SI'}
                    </strong>
                }
            })

            columns.push({ name: 'user_created', text: 'Usuario', align: 'center' })

            if (typeList === 'SALE') {
                columns.unshift({
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: r => {
                        if (parseInt(r.id_status) !== 1) {
                            return ''
                        }

                        return !customersAdded.find(c => parseInt(c.id_customers) === parseInt(r.id_customers)) ? <Button variant="dark" size="xs" data-id-customers={r.id_customers} data-id-branch-office={r.id_branch_office} data-name-branch-office={r.name_branch_office} data-email-customers={r.email_customers} data-point-current-customers={r.point_current_customers} data-full-name-customers={r.name_customers + ' ' + r.last_name_customers + ' ' + r.last_name_mot_customers} data-id-type-price={r.id_type_price} onClick={e => {
                            const { idBranchOffice, nameBranchOffice, emailCustomers, pointCurrentCustomers, fullNameCustomers, idCustomers, idTypePrice } = e.currentTarget.dataset

                            onAddCustomers({ idBranchOffice, nameBranchOffice, emailCustomers, pointCurrentCustomers, fullNameCustomers, idCustomers, idTypePrice, customers: r })
                        }}>
                            <i className="fa fa-plus"></i>
                        </Button> : <Button size="xs" variant="success">
                            <i className="fa fa-check"></i>
                        </Button>
                    }
                })
            } else {
                columns.push({
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                        if (parseInt(u.id_customers) === 1) {
                            return ''
                        }
                        return <div>
                            {actionsModule?.update && <Button variant="info" className="mr-1" size="xs" data-id-customers={u.id_customers} onClick={handleGet}>
                                <i className="fa fa-edit"></i>
                            </Button>}
                            {actionsModule?.update && <Button variant="secondary" className="mr-1" size="xs" title="Ver acceso a oficina virtual" data-id-customers={u.id_customers} onClick={handleShowCredentials}>
                                <i className="fa fa-key"></i>
                            </Button>}
                            {actionsModule?.delete && <Button variant="danger" className="mr-1" size="xs" data-id-customers={u.id_customers} data-name-customers={`${u.name_customers} ${u.last_name_customers} ${u.last_name_mot_customers}`} onClick={handleShowModalDelete}>
                                <i className="fa fa-trash"></i>
                            </Button>}
                            {u.file_contract ? <a target="_blank" rel="noreferrer" href={Helpers.config.resourcesUrl({ url: u.file_contract })}>
                                <Button variant="danger" size="xs">
                                    <i className="fa fa-file-pdf"></i>
                                </Button>
                            </a> : ''}
                        </div>
                    }
                })
            }
        }

        return <ReactDataTableBootstrap
            head={[
                columns
            ]}
            rows={rows}
            isProcessing={isProcessing}
        />
    }, [typeList, rows, isProcessing, customersAdded, onAddCustomers, actionsModule?.update, actionsModule?.delete, handleGet])

    const getData = _ => {
        setIsProccesing(true)
        Controllers.customers['get_customers_filter'](dataFilter).then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Listado De {namePlural}</span>
                {showButttonAdd ? <Button size="sm" onClick={handleGet}>
                    <i className="fa fa-plus mr-1"></i> Registrar {nameSingle}
                </Button> : ''}
            </Card.Header>
            <Card.Body>
                <ReactPlaceholder ready={ready} rows={15} showLoadingAnimation>
                    <FormCustom viewSubmit={false} className="mb-3" onSubmit={_ => {
                        if (dataFilter.p_name_customers && dataFilter.p_name_customers.toString().length < 3) {
                            Helpers.toast.construct({
                                response: 'warning',
                                message: 'Mínimo 3 caracteres en el nombre',
                                toast
                            })
                            return false
                        }

                        if (dataFilter.p_last_name_customers && dataFilter.p_last_name_customers.toString().length < 3) {
                            Helpers.toast.construct({
                                response: 'warning',
                                message: 'Mínimo 3 caracteres en el nombre',
                                toast
                            })
                            return false
                        }

                        if (dataFilter.p_last_mother_name_customers && dataFilter.p_last_mother_name_customers.toString().length < 3) {
                            Helpers.toast.construct({
                                response: 'warning',
                                message: 'Mínimo 3 caracteres en el nombre',
                                toast
                            })
                            return false
                        }
                        getData()
                    }}>
                        <Input
                            classNameParent="col-6 col-md-4 mb-2"
                            icon="far fa-user"
                            placeholder="ID Cliente"
                            text="ID Cliente"
                            type="number"
                            onChange={e => setDataFilter({ ...dataFilter, p_id_customers: e.currentTarget.value })}
                        />
                        <Input
                            classNameParent="col-6 col-md-4 mb-2"
                            icon="far fa-user"
                            placeholder="Nombres"
                            text="Nombres"
                            onChange={e => setDataFilter({ ...dataFilter, p_name_customers: e.currentTarget.value })}
                        />
                        <Input
                            classNameParent="col-6 col-md-4 mb-2"
                            icon="far fa-user"
                            placeholder="Apellido Paterno"
                            text="Apellido Paterno"
                            onChange={e => setDataFilter({ ...dataFilter, p_last_name_customers: e.currentTarget.value })}
                        />
                        <Input
                            classNameParent="col-6 col-md-4 mb-2"
                            icon="far fa-user"
                            placeholder="Apellido Materno"
                            text="Apellido Materno"
                            onChange={e => setDataFilter({ ...dataFilter, p_last_mother_name_customers: e.currentTarget.value })}
                            append={[<Button type="submit">
                                <i className="fa fa-search mr-2"></i>Buscar
                            </Button>]}
                        />
                    </FormCustom>

                    {dtRows}
                </ReactPlaceholder>
            </Card.Body>
        </Card>
        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static" size="lg">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CustomersForm key={dataUpdated?.data?.id_customers || 'new-customer'} onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} {...formParams} />
            </Modal.Body>
        </Modal>
        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_customers} - {dataDeleted.p_name_customers}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
        <SweetAlert
            icon="info"
            show={showPassword}
            showCancelButton
            title={'Datos del registro'}
            cancelButtonText="¡Ok!"
            onCancel={_ => setShowPassword(false)}
            content={_ => {
                return contentPassword
            }}
        />
    </>
}

Customers.defaultProps = {
    publicCustomers: false,
    onAddCustomers: () => { },
    customersAdded: [],
    showButttonAdd: true,
    typeList: 'DEFAULT'
}

export default Customers
